import {PageHeader} from "../components/PageHeader";
import {LegalDocument} from "../components/LegalDocument";
import {format, legalPages} from "../i18n";
import {legal} from "../legal";

// How Tristar uses AI, in src/i18n/en/legal/ai-policy.md, in the owner's own words: proofread it, don't rewrite it.
// Update legal.aiPolicyEffective with any change.
export function AiPolicyPage() {
    return (
        <div className="legal-text">
            <PageHeader title={legalPages.aiPolicy.title} description={legalPages.aiPolicy.description}/>
            <p className="text-body-secondary">{format(legalPages.effective, { date: legal.aiPolicyEffective })}</p>
            <LegalDocument markdown={legalPages.aiPolicy.document} values={legal}/>
        </div>
    );
}
